export class CorrelationRecord {

    viewrowid : number = 0;
    stage : string = '';
    market : string = '';
    morphology : string = '';
    groupingfield : string = '';
    buildingid : string = '';
    pathid : string = '';
    routeid : string = '';
    pointid : string = '';
    pointidnum : string = '';
    floornum : string = '';
    cycle : string = '';
    callimportfileid : number = 0;
    callsourceid : number = 0;
    userid : string = '';
    username : string = '';
    taskid : string = '';
    testpointid : string = '';
    calltesttype : string = '';
    completedcall : boolean = false;
    correlatedcall : boolean = false;
    timelogstarttime : Date | null = null;
    timelogendtime : Date | null = null;
    callstarttime : Date | null = null;
    timeoffset : number = 0;
    starttimeoffset : Date | null = null;
    callendtime : Date | null = null;
    callduration : number = 0;
    callsetup : number = 0;
    calltraffic : number = 0;
    calldialednum : string = '';
    callphonenum : number = 0;
    participant : string = '';
    carrier : string = '';
    os : string = '';
    make : string = '';
    modelname : string = '';
    heightoffset: number = 0;
    type : string = '';
    sourcetable : string = '';
    locimportfileid : number = 0;
    locsourceid : number = 0;
    locationprovider : string = '';
    correlationtime : Date | null = null;
    locphonenum : number = 0;
    locimei : number = 0;
    locationtime : Date | null = null;
    latitude : number = 0;
    longitude : number = 0;
    uncertaintyhoriz : number = 0;
    altitude : number = 0;
    uncertaintyvert : number = 0;
    rantech : string = '';
    technology : string = '';
    summarytech : string = '';
    timetofix : number = 0;
    validhorizlocation : boolean = false;
    validvertlocation : boolean = false;
    choosen: boolean = false;
    horizontalerror : number = 0;
    altitudeerror : number = 0;
    verticalerror : number = 0;
    avgbarometricpressure : number = 0;
    comments : string = '';
}

export const isAndroid = (os:string) => os?.toLowerCase().indexOf('android') >= 0;
export const isIos = (os:string) => os?.toLowerCase().indexOf('ios') >= 0;

